import { FC } from 'react';

import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    Loading,
    LoadingButton,
} from '@thirdspacelearning/library';

interface Props {
    open: boolean;
    loading: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const RestartLessonDialog: FC<Props> = ({
    open,
    loading,
    onClose,
    onConfirm,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            data-testid="restart-lesson-dialog"
        >
            <DialogTitle
                fontWeight="bold"
                textAlign="center"
                color="primary.dark"
                sx={{ pt: 4 }}
            >
                Are you sure you want to restart the lesson from the beginning?
            </DialogTitle>
            <DialogActions sx={{ justifyContent: 'center', pb: 4 }}>
                <Button
                    variant="contained"
                    onClick={onClose}
                    data-testid="restart-lesson-goback-btn"
                >
                    Go back
                </Button>
                <LoadingButton
                    variant="outlined"
                    loading={loading}
                    loadingIndicator={<Loading size={24} />}
                    onClick={onConfirm}
                    data-testid="restart-lesson-confirm-btn"
                >
                    Restart Lesson
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default RestartLessonDialog;
